<template>
    <ul class="text-base">
        <li
            v-for="(resourceGroup, groupType) in resources"
            :key="groupType"
            class="block gap-2 py-4 pl-0 border-b border-b-keyline-secondary first:border-t first:border-t-keyline-secondary"
            @click.prevent="
                    resourceOpen[groupType]
                        ? (resourceOpen[groupType] = false)
                        : (resourceOpen[groupType] = true)
                "
        >
            <button
                class="type-secondary hover:type-primary flex items-center gap-2 font-bold capitalize w-full"
                :class="{
                    '!type-primary' : resourceOpen[groupType],
                }"
            >
                <BaseSvg
                    :name="
                        resourceOpen[groupType]
                            ? 'icon-expand-less'
                            : 'icon-expand-more'
                    "
                    class="w-6 h-6 type-secondary"
                />
                {{ groupType }}
            </button>
            <ul v-if="resourceOpen[groupType]" class="pt-3">
                <li v-for="(resource, i) in resourceGroup" :key="i">
                    <div class="flex items-center gap-4 py-2 px-3 text-base hover:bg-gray-tier-5 rounded-sm">
                        <BaseSvg
                            :name="getIcon(groupType)"
                            class="w-6 h-auto shrink-0 type-tertiary"
                        />
                        <button
                            @click.stop.prevent="getResource($event, resource)"
                            class="text-left hover:underline underline-offset-4 decoration-1 capitalize truncate max-w-[80%]"
                        >
                            {{ resource.name }}
                        </button>

                        <div class="hidden at1024:flex items-center justify-end gap-8 whitespace-nowrap col-span-1 ml-auto">
                            <span
                                class="hidden at1200:block type-secondary"
                            >
                                {{ resource?.asset?.updated_at ? DateTime.fromISO(resource?.asset?.updated_at).toLocaleString(DateTime.DATE_MED) : "–"}}
                            </span>
                            <button
                                class="group w-6 h-auto"
                                v-if="resource.asset.source === 3"
                                @click.stop="
                                    forceDownload(
                                        $event,
                                        marketingAssetUrl(
                                            resource.asset.external_id
                                        ),
                                        _.kebabCase(resource.name) + '.pdf'
                                    )
                                "
                            >
                                <BaseSvg
                                    class="group-hover:fill-red shrink-0"
                                    name="icon-export-file"
                                />
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script setup>
import { BaseSvg } from "@/Components";
import { useAssetTransforms, useDownload, useResources } from "@/Composables";
import { ref } from "vue";
import _ from "lodash";
import { DateTime } from "luxon";

const props = defineProps({
    resources: {
        type: Array,
        required: false,
    },
    icons: {
        type: Array,
        required: true,
    },
    getIcon: {
        type: Function,
        required: true,
    },
});

const resourceOpen = ref({});

const { getResource } = useResources();
const { marketingAssetUrl } = useAssetTransforms();
const { forceDownload } = useDownload();
</script>
